import styled from 'styled-components';

import { Modal as AntModal } from 'antd';

export default styled(AntModal)`
  .ant-modal-content {
    border-radius: 6px;
  }
`;
